import * as React from 'react';
import { PaymentMethodsListProps } from '../../../../types/AdaptedComponents';
import { UILibrary } from '../../../../types/UILibrary';
import { RadioButtonGroup } from 'wix-ui-tpa/RadioButtonGroup';
import { RadioButton, RadioButtonTheme } from 'wix-ui-tpa/RadioButton';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { classes } from './styles.st.css';
import { PaymentMethodIcon } from '../../../PaymentMethodIcon';
import { SavedCreditCardItem } from './elements';
import { DH } from '../../../../utils/DataHook';
import cn from 'classnames';

export const PaymentMethodsList: React.FC<PaymentMethodsListProps> = (
  props
) => {
  const onChange = (value) => {
    const selectedCard = props.creditCards.find(
      (card) => card.creditCardId === value
    );
    if (selectedCard) {
      props.onSavedCreditCardChanged(selectedCard.creditCardId, {
        billingAddress: selectedCard.billingAddress,
        additionalInformation: selectedCard.additionalInformation,
        expired: selectedCard.expired,
        expiration: selectedCard.expiration,
        network: selectedCard.network,
      });
    }
    props.onPaymentMethodChanged(value as PaymentMethod);
  };

  const selectedItem = props.selectedCardId || props.selectedMethod;
  return (
    <div data-ui-lib={'tpa' as UILibrary} data-hook={'wcn-step-paymentMethod'}>
      <RadioButtonGroup
        name="paymentMethodsList"
        theme={RadioButtonTheme.Box}
        className={classes.radioButtonGroup}
        value={selectedItem}
        onChange={onChange}
      >
        {props.creditCards.map((card) => [
          <RadioButton
            key={card.creditCardId}
            className={cn(classes.groupItem, classes.methodTitle)}
            label={card.creditCardId}
            value={card.creditCardId}
            error={card.expired}
            data-hook={DH.SavedCard.Item.Wrapper(card.creditCardId)}
          >
            <SavedCreditCardItem {...card} />
          </RadioButton>,
          !!props.activePaymentComponentNode &&
          selectedItem === card.creditCardId ? (
            <div
              className={classes.groupItem}
              data-hook={DH.MethodsList.ScreenWrapper}
            >
              {props.activePaymentComponentNode}
            </div>
          ) : null,
        ])}
        {props.paymentMethods.map((method) => {
          return [
            <RadioButton
              data-hook={DH.MethodsList.Item.Wrapper(method.value)}
              key={method.value}
              className={cn(classes.groupItem, classes.methodTitle)}
              value={method.value}
              aria-label={method.label}
            >
              <div
                className={cn({
                  [classes.methodTitleContainer]: true,
                  [classes.creditCardTitle]:
                    method.value === PaymentMethod.CreditCard,
                })}
              >
                <span>{method.label}</span>
                <div className={classes.icon}>
                  <PaymentMethodIcon
                    paymentMethod={method.value as PaymentMethod}
                    providerId={method.connectedProviderId}
                    url={method.icon}
                    lang={props.locale}
                  />
                </div>
              </div>
            </RadioButton>,
            !!props.activePaymentComponentNode &&
            selectedItem === method.value ? (
              <div
                className={classes.groupItem}
                data-hook={DH.MethodsList.ScreenWrapper}
              >
                {props.activePaymentComponentNode}
              </div>
            ) : null,
          ];
        })}
      </RadioButtonGroup>
    </div>
  );
};
PaymentMethodsList.displayName = 'PaymentMethodsList';
